import { render, staticRenderFns } from "./ScanDocumentsView.vue?vue&type=template&id=0d7fe69e&scoped=true"
import script from "./ScanDocumentsView.vue?vue&type=script&lang=js"
export * from "./ScanDocumentsView.vue?vue&type=script&lang=js"
import style0 from "./ScanDocumentsView.vue?vue&type=style&index=0&id=0d7fe69e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7fe69e",
  null
  
)

export default component.exports